import "./TermsPage.css";

function TermsPage() {
    return (
        <div className="text-left p-10 md:px-20 container mx-auto">
            <h1 className="pb-10 text-6xl">Terms and Conditions</h1>

            <p>Hey there! Welcome to self-affirmations.net. This is a personal project I created to help you practice self-affirmations in a fun, simple way. Here are my easy-to-follow rules:</p>

            <h2 className="pt-10 pb-3 font-bold text-4xl">
                <span className="colored-underline">About This Website</span>
            </h2>
            
            <ul>
                <li>This website is my personal project—I'm not a big company, just one person who loves self-affirmations and wanted to make a helpful tool for you.</li>
                <li><span className="font-bold">Email:</span> <a href="mailto:info@self-affirmations.net">info@self-affirmations.net</a></li>
            </ul>

            <h2 className="pt-10 pb-3 font-bold text-4xl">
                <span className="colored-underline">What This Website Does</span>
            </h2>
            
            <ul>
                <li>I designed this website so you can practice self-affirmations using a mirror image from a selfie-camera.</li>
                <li>The website is free to use, and I earn a small commission if you use products or services from the ads.</li>
            </ul>

            <h2 className="pt-10 pb-3 font-bold text-4xl">
                <span className="colored-underline">How to Use This Website</span>
            </h2>
            
            <ul>
                <li><span className="font-bold">At Your Own Risk:</span> Enjoy using the website, but please remember you're doing it on your own. I can't be responsible for any outcomes.</li>
                <li><span className="font-bold">No Cheating:</span> Please avoid using web-scrapers or any other automation tools here.</li>
                <li><span className="font-bold">Personal Use Only:</span> This website is for your personal self-affirmation practice. It's not meant for commercial use or promotions.</li>
                <li><span className="font-bold">Be Nice:</span> Please don't try to change or break the website.</li>
            </ul>

            <h2 className="pt-10 pb-3 font-bold text-4xl">
                <span className="colored-underline">Ads</span>
            </h2>
            
            <ul>
                <li>Although the website is free, you may see some ads.</li>
                <li>If you sign up or use products and services on those websites, I might earn a small commission.</li>
            </ul>

            <h2 className="pt-10 pb-3 font-bold text-4xl">
                <span className="colored-underline">Links</span>
            </h2>
            
            <ul>
                <li>The website may include links to other websites.</li>
                <li>These links point to external websites that have their own Terms & Conditions and Privacy Policies, which are out of my control. Please take a moment to review them on their own websites.</li>
            </ul>

            <h2 className="pt-10 pb-3 font-bold text-4xl">
                <span className="colored-underline">My Promise About Health Info</span>
            </h2>
            
            <ul>
                <li><span className="font-bold">Use at Your Own Risk:</span> This website is here for inspiration and fun. It's not a replacement for advice from a doctor or other health professional.</li>
                <li>I'm not a health expert—if you have health concerns, please consult a professional.</li>
            </ul>

            <h2 className="pt-10 pb-3 font-bold text-4xl">
                <span className="colored-underline">What You Shouldn't Do</span>
            </h2>
            
            <ul>
                <li><span className="font-bold">No Hacking:</span> Please don't try to hack, scrape, or overload the website.</li>
                <li><span className="font-bold">No Claiming Ownership:</span> You can't claim you made the website, its idea, its images, or its design.</li>
                <li><span className="font-bold">Stay Legal:</span> Use the website only for lawful and friendly purposes.</li>
            </ul>

            <h2 className="pt-10 pb-3 font-bold text-4xl">
                <span className="colored-underline">Final Note</span>
            </h2>
            
            <p>By using self-affirmations.net, you agree to these simple rules. If I update them, using the website means you accept the new rules.</p>
            <br></br>
            <p>Thanks for stopping by, and I hope this website helps you embrace your self-affirmations every day!</p>

        </div>
    );
}

export default TermsPage;
